/* eslint-disable no-unused-vars */
import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { axiosBaseQuery } from '../axios/index';

export const monthlyBudgetAPI = createApi({
  reducerPath: 'MonthlyBudgetAPI',
  baseQuery: axiosBaseQuery({ baseUrl: '/api/Campaign' }),
  tagTypes: ['GetMonthlyBudgetApps'],
  endpoints: (build) => ({
    getMonthlyBudgetApps: build.query({
      query: (data) => ({
        url: '/GetMonthlyBudgetApps',
        data,
        method: 'POST',
      }),
      transformResponse: (response) => {
        return response.sort((a, b) => {
          if (
            a.activeCampaigns > 0 &&
            a.budgetToUse !== 0 &&
            !(b.activeCampaigns > 0 && b.budgetToUse !== 0)
          ) {
            return -1;
          }
          if (
            b.activeCampaigns > 0 &&
            b.budgetToUse !== 0 &&
            !(a.activeCampaigns > 0 && a.budgetToUse !== 0)
          ) {
            return 1;
          }
          if (a.activeCampaigns > 0 && b.activeCampaigns > 0) {
            if (b.activeCampaigns !== a.activeCampaigns)
              return b.activeCampaigns - a.activeCampaigns;
            return a.budgetToUse - b.budgetToUse;
          }
          if (
            a.budgetToUse !== 0 &&
            a.activeCampaigns === 0 &&
            !(b.budgetToUse !== 0 && b.activeCampaigns === 0)
          ) {
            return -1;
          }
          if (
            b.budgetToUse !== 0 &&
            b.activeCampaigns === 0 &&
            !(a.budgetToUse !== 0 && a.activeCampaigns === 0)
          ) {
            return 1;
          }
          if (a.budgetToUse !== 0 && b.budgetToUse !== 0) {
            return a.budgetToUse - b.budgetToUse;
          }
          if (
            a.activeCampaigns > 0 &&
            a.budgetToUse === 0 &&
            !(b.activeCampaigns > 0 && b.budgetToUse === 0)
          ) {
            return -1;
          }
          if (
            b.activeCampaigns > 0 &&
            b.budgetToUse === 0 &&
            !(a.activeCampaigns > 0 && a.budgetToUse === 0)
          ) {
            return 1;
          }
          if (a.activeCampaigns > 0 && b.activeCampaigns > 0) {
            return b.activeCampaigns - a.activeCampaigns;
          }
          return 0;
        });
      },
      providesTags: ['Campaign/GetMonthlyBudgetApps'],
    }),
    saveMonthlyBudgetApps: build.mutation({
      query: (data) => ({
        url: '/SaveMonthlyBudgetApps',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        data,
      }),
    }),
  }),
});

// export const monthlyBudgetAPI = createApi({
//   reducerPath: 'MonthlyBudgetAPI',
//   baseQuery: axiosBaseQuery({ baseUrl: 'api/Budget' }),
//   tagTypes: ['GetMonthlyBudgetApps'],
//   endpoints: (build) => ({
//     GetMonthlyBudgetApps: build.query({
//       query: () => ({
//         url: `/GetMonthlyBudgetApps`,
//       }),
//       transformResponse: (response) => {
//         return response.map((item) => {
//           const renderedCountries =
//             item.countries && item.countries?.length > 0
//               ? `${item.countries
//                   ?.slice() // for frozen array
//                   ?.sort((a, b) => a.localeCompare(b))
//                   ?.slice(0, 3)
//                   ?.join(', ')}${
//                   item.countries?.length > 3 ? ', +' + (item.countries?.length - 3) : ''
//                 }`
//               : '–';
//           return {
//             ...item,
//             renderedCountries,
//           };
//         });
//       },
//       providesTags: ['GetMonthlyBudgetApps'],
//     }),
//     GetCountries: build.query({
//       query: () => ({
//         url: `/GetCountries`,
//       }),
//     }),
//     SaveMonthlyBudgetApps: build.mutation({
//       query: (data) => ({
//         url: `/SaveMonthlyBudgetApps`,
//         method: 'POST',
//         data,
//       }),
//       //invalidatesTags: ['GetMonthlyBudgetApps'],
//     }),
//   }),
// });
